import { render, staticRenderFns } from "./matching-sidebar.vue?vue&type=template&id=68151b08&scoped=true&"
import script from "./matching-sidebar.vue?vue&type=script&lang=ts&"
export * from "./matching-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./matching-sidebar.vue?vue&type=style&index=0&id=68151b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68151b08",
  null
  
)

export default component.exports